import { Observable } from 'rxjs';
import { ApiService } from '../../../core/services';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PowerbiReportApiModel } from '../../../shared/models/powerbi-report-api.model';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PowerbiService {
  apiUrl: string;

  constructor(private apiService: ApiService, private httpClient: HttpClient) {
    this.apiUrl = `${this.apiService.apiUrl}`;
  }

  getReport(env: number, type: number, botId: number): Observable<PowerbiReportApiModel> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-key': environment.xApiKey
    });

    return this.httpClient.get<PowerbiReportApiModel>(
      `${this.apiUrl}powerbi/report?env=${env}&type=${type}&botId=${botId}`,
      { headers }
    );
  }

  getUserErrorMessage(error: any, fallback: string): string {
    const message =
      error?.error?.message ||
      error?.error?.error?.message ||
      error?.message?.message;

    return typeof message === 'string' && message.trim().length > 0
      ? message
      : fallback;
  }
}
